/** Template types whose reports scope by transaction type, so the picker is
 *  shown and its selection is persisted. Every other type must submit no node
 *  ids — the backend rejects them for unsupported report types. */
const TRANSACTION_TYPE_TEMPLATE_TYPES: ReadonlySet<string> = new Set([
  "CAPITAL_CALL_NOTICE",
  "DISTRIBUTION_NOTICE",
]);

export const supportsTransactionTypes = (templateType: string | null | undefined): boolean =>
  templateType != null && TRANSACTION_TYPE_TEMPLATE_TYPES.has(templateType);

export const toTransactionTypeNodeIds = (values: {
  supportedTemplateType: string;
  supportedTransactionTypes: number[];
}): number[] =>
  supportsTransactionTypes(values.supportedTemplateType)
    ? values.supportedTransactionTypes
    : [];
